import { find } from 'lodash';

const countriesConfig = require('../configs/countries.config.json');

export default (item) => {
    let result = {};
    
    const regexpUnnamedRoad = new RegExp('Unnamed Road, ','gi');
    const formattedAddress = item.full_name.replace(regexpUnnamedRoad, '');
    result.formatted_address = formattedAddress;

    if (item.point) {
        result.coords = item.point;
    }

    let [city] = item.adm_div.filter((item) => {
        return item.type === 'city'
            || item.subtype === 'city'
            || item.type === 'settlement'
            || item.subtype === 'settlement';
    });

    if (!city && item.type === 'city' || item.subtype === 'city') {
        result.street = item.name;
        result.city = item.name;
    }

    const [region] = item.adm_div.filter((item) => item.type === 'region');
    const [district] = item.adm_div.filter((item) => item.type === 'district_area');

    if (region) {
        result.region = region.name;
    }

    if (city) {
        result.street = city.name;
        result.city = city.name;
    }

    if (district) {
        result.area = district.name;
    }

    result.country_iso = item.locale.substring(3);
    result.country = 1;

    if (result.country_iso) {
        let countryField = find(countriesConfig, {iso: result.country_iso});

        if (countryField) {
            result.country = countryField.id;
        } else {
            result.country = null;
        }
    }

    result.isTwoGis = true;

    return result;
}



// WEBPACK FOOTER //
// ./tools/transform-2gis-geocoded-data.js